import { Link } from 'react-router-dom';
import './homepagerecipes.scss';

// Placeholder cards while the page content loads, so the page doesn't jump when it arrives.
const PLACEHOLDER_COUNT = 3;

// `cards` is null while loading; each card is { title, text, image, link }.
export default function HomePageRecipes({ heading, cards, isAdmin }) {
  if (cards?.length === 0 && !isAdmin) return null;

  return (
    <section className="hp-section">
      <div className="hp-section-header">
        <h2 className="hp-section-title">{heading}</h2>
        <Link to="/Recipes" className="hp-section-link">
          Explore recipes <span aria-hidden="true">→</span>
        </Link>
      </div>

      {cards === null && (
        <ul className="hp-recipe-grid" aria-busy="true" aria-label="Loading recipes">
          {Array.from({ length: PLACEHOLDER_COUNT }, (_, index) => (
            <li key={index} className="hp-recipe is-placeholder" aria-hidden="true">
              <div className="hp-recipe-image" />
            </li>
          ))}
        </ul>
      )}

      {cards?.length > 0 && (
        <ul className="hp-recipe-grid">
          {cards.map((card, index) => (
            <li key={index} className="hp-recipe">
              <Link to={card.link} className="hp-recipe-link">
                <div className="hp-recipe-image">
                  {card.image && (
                    <img src={card.image} alt="" loading="lazy" decoding="async" width="600" height="480" />
                  )}
                </div>
                <h3 className="hp-recipe-title">{card.title}</h3>
                {card.text && <p className="hp-recipe-text">{card.text}</p>}
              </Link>
            </li>
          ))}
        </ul>
      )}

      {cards?.length === 0 && (
        <p className="hp-admin-note">
          There are no recipe cards, so visitors don't see this section. Use Edit home page to add some.
        </p>
      )}
    </section>
  );
}
